import React from 'react';

const YouTube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="2.5" y="5.5" width="19" height="13" rx="1.5" stroke="black" />
    <path d="M10.5 15.0657V8.93426L15.0986 12L10.5 15.0657Z" stroke="black" />
  </svg>
);

export default YouTube;
